export default "__VITE_ASSET__TijZaWmc__"